import DTO from './DTO';

class SessionFormDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'find',
        type: String,
        labelKey: 'search',
      },
      {
        name: 'date',
        type: String,
        labelKey: 'violation.date',
      },
      {
        name: 'start_time',
        type: String,
        labelKey: 'violation.date',
      },
      {
        name: 'date_start',
        type: String,
        labelKey: 'date_start',
      },
      {
        name: 'date_end',
        type: String,
        labelKey: 'date_end',
      },
      {
        name: 'session_type',
        type: String,
        labelKey: 'session_type',
      },
      {
        name: 'reg_number',
        type: String,
        labelKey: 'reg_number',
      },
      {
        name: 'show_conditionally_recognized',
        type: Boolean,
        labelKey: 'show_conditionally_recognized',
      },
      {
        name: 'car_type',
        type: String,
        labelKey: 'car_type',
      },
      {
        name: 'camera',
        type: String,
        labelKey: 'camera',
      },
      {
        name: 'zone',
        type: String,
        labelKey: 'zone',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default SessionFormDTO;
